import { getProductIdFromProductCode } from '@noths/polaris-client-utils';

import type { Product } from 'src/redux/products/types/Product';

export const transformProductsToGAReturnedProductsArray = (products: Product[]) => {
  return products.map(({ code }) => ({
    product: {
      id: String(getProductIdFromProductCode(code)),
    },
  }));
};
